import { useState, useEffect, Fragment } from "react";
import { useParams, useHistory } from "react-router-dom";
import { API_URL, scroll, setValToLS } from "../helpers";
import Alert from "../components/Alert";

const Payment = () => {
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const { str } = useParams();
  const history = useHistory();

  useEffect(() => {
    scroll();
    const init = async () => {
      const url = new URL(`${API_URL}/dashboardInit`);
      const params = {
        dashId: str ? str : "",
      };
      url.search = new URLSearchParams(params);

      try {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });
        const json = await response.json();
        if (json && json.resp === 1) {
          const auth = {
            id: json.id,
            type: json.type,
            fname: json.fname,
            email: json.email,
            organization: json.organization || "",
            liaison: json.liaison,
          };
          setValToLS("dash", JSON.stringify(auth), true);
          history.push("/dashboard/invoice");
        } else {
          setAlert({
            type: json.resp === 2 ? "notice" : "error",
            text: json.text,
          });
        }
      } catch (error) {
        setAlert({
          type: "error",
          text: "An error has occurred.",
        });
      }
    };

    init();

    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>{alert.type ? <Alert data={alert} /> : <Fragment />}</Fragment>
  );
};

export default Payment;
